var annualReportNavigation = require('../mixins/annual-report-navigation')
var NOTIFICATION_KEYS = require('../notificationKeys')
var t = require('i18n').t

module.exports = Em.Controller.extend(annualReportNavigation, {
    actions: {
        didClickApprove: function() {
            var self = this
            self.set('isLoading', true)

            this.get('items').forEach(function(section) {
                section.validate && section.validate()
            })

            var year = this.get('model.commitment.year')

            if (!year) {
                // Cannot do a console because of lint being too strict about that.
                // console.warn('missing year, cannot submit controlled transactions')
                return
            }

            var areAllFieldsValid = this.get('items').filterBy('isValid', false).length === 0

            if (areAllFieldsValid) {
                this.get('annualReport')
                    .putSteps(year, { controlled_transactions: true })
                    .then(function() {
                        self.send('navigateToNextStep')
                    }).catch(function() {
                        self.set('isLoading', false)
                    })
            } else {
                self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.AR_INFO_APPROVE, t('annual_report.field_validation_errors.incomplete_fields'))
                self.set('isLoading', false)
            }
        }
    }
})
